export default theme => ({
  root: {
    padding: theme.spacing(0),
  },
  gridItem: {
    padding: theme.spacing(0),
    minWidth: '650px',
    minHeight: 'calc(-195px + 100vh)',
  },
  tourTable: {
    marginBottom: theme.spacing(2),
  },
  button: {
    float: 'right',
    marginLeft: theme.spacing(1)
  },
  redButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.danger.main,
    '&:hover': {
      backgroundColor: theme.palette.danger.dark,
      color: theme.palette.common.white,
    }
  },
  displaySelectedTourCheckbox: {
    float: 'right',
    marginTop: -theme.spacing(5)
  }
});
